import { Routes, Route, Navigate } from 'react-router-dom'

import SurveyList from 'Presentation/Views/Survey/List/View'
import FormSurvey from 'Presentation/Views/Survey/Form/View'
import SurveyDetailView from 'Presentation/Views/Survey/Detail/View'
import SurveyFormTab from 'Presentation/Views/Survey/Detail/Tabs/FormTab'
import SurveyProductionOrderRequestTab from 'Presentation/Views/Survey/Detail/Tabs/ProductionOrderRequest'
import SurveyWorkOpeningNoticeTab from 'Presentation/Views/Survey/Detail/Tabs/WorkOpeningNotice'
import SurveyAttachmentsTab from 'Presentation/Views/Survey/Detail/Tabs/Attachments'
import SurveySalesAttachmentsTab from 'Presentation/Views/Survey/Detail/Tabs/SalesAttachments'
import { SurveyViewContextProvider } from 'Presentation/Views/Survey/Context'
import { FormSurveyContextProvider } from 'Presentation/Views/Survey/Form/Context'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const SurveyRoutes = () => (
  <SurveyViewContextProvider>
    <FormSurveyContextProvider>
      <Routes>
        <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.survey} />}>
          <Route path='create' element={<FormSurvey />} />

          <Route
            path=':id/*'
            element={
              <FormSurveyContextProvider>
                <SurveyDetailView />
              </FormSurveyContextProvider>
            }>
            <Route path='form' element={<SurveyFormTab />} />
            <Route path='production-order-approval-form' element={<SurveyProductionOrderRequestTab />} />
            <Route path='work-opening-notice' element={<SurveyWorkOpeningNoticeTab />} />
            <Route path='attachments' element={<SurveyAttachmentsTab />} />
            <Route
              element={
                <ProtectedRoutePermission
                  whitelist={RolePermissionConfigs.survey_sales_attachment}
                />
              }>
              <Route path='sales-attachments' element={<SurveySalesAttachmentsTab />} />
            </Route>
            <Route index element={<Navigate to='form' replace />} />
          </Route>

          <Route index element={<SurveyList />} />

          <Route path='*' element={<Navigate to='/home' />} />
        </Route>
      </Routes>
    </FormSurveyContextProvider>
  </SurveyViewContextProvider>
)

export default SurveyRoutes
